import { HTMLTable } from '@blueprintjs/core';
import { ReactNode } from 'react';
import Pagination from '../../views/users/components/pagination/pagination';
import { TableContainer } from './styles';

export interface Column<T> {
  title: string;
  render: (record: T) => ReactNode;
}
interface PaginationConfig {
  totalPages: number;
  currentPage: number;
  onPageChange: (pageNumber: number) => void;
}
interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  rowKey: keyof T;
  pagination?: PaginationConfig;
  bordered?: boolean;
  compact?: boolean;
  interactive?: boolean;
  striped?: boolean;
}
const Table = <T extends object>({
  columns,
  data,
  rowKey,
  bordered,
  compact,
  interactive,
  striped,
  pagination,
}: TableProps<T>) => {
  return (
    <TableContainer>
      <HTMLTable
        bordered={bordered}
        compact={compact}
        interactive={interactive}
        striped={striped}
      >
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index}>{column.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={String(item[rowKey])}>
              {columns.map((column, index) => (
                <td key={index}>{column.render(item)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </HTMLTable>
      {pagination && (
        <Pagination
          currentPage={pagination.currentPage}
          onPageChange={pagination.onPageChange}
          totalPages={pagination.totalPages}
        />
      )}
    </TableContainer>
  );
};

export default Table;
